import React from 'react'
import { Container, Radio, RadioGroup, useTheme } from '@mui/material'

import { Field, InputOption } from '../../types'
import Text from '../Text'

interface ConsentFormSingleSelectProps {
  readonly disabled: boolean
  readonly field: Field
  readonly label: string
  readonly onChange?: (value: string) => void
  readonly options: InputOption[]
}

export function ConsentFormSingleSelect({
  disabled,
  label,
  field,
  options,
  onChange,
}: ConsentFormSingleSelectProps) {
  const theme = useTheme()

  return (
    <>
      <Text>{label}</Text>
      <RadioGroup>
        {options.map(option => (
          <Container
            disableGutters
            key={option.id}
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              marginTop: `${theme.spacing(1)}`,
              '& .MuiRadio-root': {
                paddingTop: 0,
                paddingLeft: 0,
              },
            }}
          >
            <Radio
              checked={field.value === option.name}
              disabled={disabled}
              key={option.id}
              value={option.name}
              onChange={e => {
                field.setValue(e.target.value)
                onChange?.(option.id)
              }}
            />
            <Text>{option.name}</Text>
          </Container>
        ))}
      </RadioGroup>
    </>
  )
}
